import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from "ngx-cookie-service";
import { SharedService } from "../helper/shared/shared.service";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  //webServiceUrl = "http://localhost:50889/WebService/";       // local Development
  // webServiceUrl = "https://cfss.camfil.net/CFSSWebService/WebService/";    // Live
  //webServiceUrl = "https://cfss.camfil.net/CFSSWebServiceDev2/WebService/";    // Development
  //webServiceUrl = "http://SETR-3-77.camfil.dmz/CFSSWebServiceDev2/WebService/";    // SETR-3-77

  constructor(
    private httpService: HttpClient,
    public cookieSvc: CookieService,
  ) {
  }

  //Modified by JW(2025-10-03): Azure DevOps #116276-start

  //local
  // getUsers(email: string, password: string) {
  //   return this.httpService.post(SharedService.webServiceUrl + "ValidateAccount2", { EmailID: email, Password: password }); //local
  //   //return this.httpService.post(SharedService.webServiceUrl + "ValidateAccount2", { pValidate: { EmailID: email, Password: password } }); //live
  // }
  //live
  getUsers(email: string, password: string): Observable<{ LoginCode: string }> {
    const url = `${SharedService.webServiceUrl}ValidateAccountForAzureApps`;
    const payload = { pValidate: { EmailID: email.trim(), Password: password.trim() } };
    return this.httpService.post<{ LoginCode: string }>(url, payload);
  }

  validateTokenTime(loginCode: string): Observable<number> {
    const url = `${SharedService.webServiceUrl}LoginCodeRemainingActiveSecond_ForAzure`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //const body = { LoginCode: loginCode }; //local
    const body = { pLoginCode: { LoginCode: loginCode } }; //live

    return this.httpService
      .post(url, body, { headers, responseType: 'text' as const })
      .pipe(
        map((raw: string) => Number((raw ?? '').trim()) || 0)
      );
  }
  //Modified by JW(2025-10-03): Azure DevOps #116276-end

  getAccessRight(logincode: any) {
   // return this.httpService.post(SharedService.webServiceUrl + "RetrieveAccountAccessRights", { LoginCode: logincode }); //local
    return this.httpService.post(SharedService.webServiceUrl + "RetrieveAccountAccessRights", { pLoginCode: { LoginCode: logincode } });  //live    
  }

  setCookie(loginCode: any): void {
    this.cookieSvc.set("CFSSLoginCode", loginCode);
    this.cookieSvc.get("CFSSLoginCode");
  }
}
